export function getViewportHeightUnit(): 'dvh' | 'vh' {
  return typeof CSS !== 'undefined' && CSS.supports('height', '100dvh')
    ? 'dvh'
    : 'vh';
}

/** calc(100{dvh|vh} - ...)，优先 dvh，不支持时回退 vh */
export function calcViewportHeight(...deductions: string[]): string {
  const unit = getViewportHeightUnit();
  if (deductions.length === 0) {
    return `100${unit}`;
  }
  return `calc(100${unit} - ${deductions.join(' - ')})`;
}

/** 移动端全屏抽屉高度，扣除顶部安全区 */
export const MOBILE_DRAWER_HEIGHT = calcViewportHeight(
  'env(safe-area-inset-top, 0px)'
);
